import { render, staticRenderFns } from "./NewsletterLanding.vue?vue&type=template&id=3029ce12"
import script from "./NewsletterLanding.vue?vue&type=script&lang=js"
export * from "./NewsletterLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports